<template>
  <div class="box">
    <b-overlay :show="loading" rounded="sm" opacity="0.5">
      <div class="top">
        <img class="image" src="" alt="" />
      </div>
      <div class="center">
        <h3 class="title">
          欢迎下载湖北成人教育管理平台手机APP
        </h3>
        <p class="centerTitle">请点击下面的下载按钮</p>
        <div class="buttonBox">
          <a :href="iosUrl"
            ><img
              style="width:146px;height:46px"
              src="../assets/ios-btn.png"
              alt="苹果版下载"
          /></a>
          <a @click="isWechat"
            ><img
              style="width:146px;height:46px"
              src="../assets/android-btn.png"
              alt="安卓版下载"
          /></a>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      androidUrl: "",
      iosUrl: "",
      weixin: false
    };
  },
  mounted() {
    this.isWeixin();
    this.getDownloadUrl();
  },
  methods: {
    isWechat() {
      if (this.weixin) {
        this.$message({
          message: "请点击右上角 ...按钮, 选择在浏览器中打开!",
          type: "warning"
        })
        return false
      }else {
        location.href = this.androidUrl
      }
    },
    isWeixin() {
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.weixin = true;
      } else {
        this.weixin = false;
      }
    },
    async getDownloadUrl() {
      this.loading = true;
      try {
        const { data } = await this.axios.get(`/comm/findLatestAppVersion`);
        this.androidUrl = data.android.url;
        this.iosUrl = `https://apps.apple.com/cn/app/%E5%8C%A0%E5%BF%83%E4%BA%91%E5%AD%A6%E5%A0%82/id${data.ios.url}`;
      } catch (error) {
        return;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.box {
  height: 100%;
  margin: 0;
  overflow-x: auto;
  color: #323233;
  font-size: 16px;
  background-color: #f7f8fa;
}
.top {
  text-align: center;
  padding-top: 6em;
  padding-bottom: 1em;
}
.image {
  max-width: 100%;
  height: 5em;
  min-height: 5em;
}
.center {
  display: flex;
  flex-direction: column;
}
.title {
  font-weight: bold;
  text-align: center;
  padding: 0 6.8%;
}
.centerTitle {
  font-size: 1.4em;
  text-align: center;
  color: #8e8f90;
}
.buttonBox {
  text-align: center;
}
</style>
